import Analytics from '@analytics/index';

let dispatchedResume: boolean = false;

const dispatchedResumedEvent = (lastCompletedStep: any) => {
  // Only dispatch once
  if (!dispatchedResume) {
    // Set dispatchedResume to true so it only triggers on first render
    dispatchedResume = true;

    // send to Analytics
    Analytics.EventAnalytics.track('registration_resumed', {
      page_viewed: lastCompletedStep,
    });
  }
};
// Filters by lastCompletedStep.  Allows us to skip steps that have already been completed
// Dispatches analytics event if form is being resumed based on presence of lastCompletedStep in data
const filterByLastCompletedStep = (steps: any, data: any) => {
  // If there is a last completed step and we're not in a gdpr compliant context, allow for resuming
  const { lastCompletedStep } = data;
  if (lastCompletedStep && !data.requiresGDPRCompliance) {
    dispatchedResumedEvent(lastCompletedStep);
    return steps;
  }
  return steps;
};

export default filterByLastCompletedStep;
